import { CAN_SURVEY } from "constants/appNames";

export const APP_NAME = Object.freeze({
	CAN_SDS: 'SDS',
	CAN_APPS: 'CANapps',
	CAN_DISPATCH: 'CANdispatch',
	CAN_TRACK: 'CANtrack',
	CAN_MAIL: 'CANmail',
	ROUTE_CANSHARE: 'CANshare',
	CAN_SENSE: 'CANsense',
	CAN_WORK: 'CANwork',
	CAN_PROSPECT: 'CANprospect',
	CAN_WEBSITE: 'CANwebsite',
	CAMFM: 'CAMFMapps',
	CAN_PARK: 'CANpark',
	CAN_MEET: 'CANmeet',
	CAN_SURVEY: 'CANsurvey',
	CAN_BLOG: 'CANblog',
	CAN_AI: 'CANai',
	CAN_VMS: 'CANvision',
});
